// @flow
import { NoticiasActionTypes } from './constants';

type NoticiasAction = { type: string, payload: {} | string };

// common success
export const noticiasApiResponseSuccess = (actionType: string, data: any): NoticiasAction => ({
    type: NoticiasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const noticiasApiResponseError = (actionType: string, error: string): NoticiasAction => ({
    type: NoticiasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getNoticia = (id: string): NoticiasAction => ({
    type: NoticiasActionTypes.GET_NOTICIA,
    payload: { id },
});

export const addNoticia = (noticia:any):NoticiasAction=>({
    type:NoticiasActionTypes.ADD_NOTICIA,
    payload:noticia
})
export const updateNoticia = (noticia:any):NoticiasAction=>({
    type:NoticiasActionTypes.UPDATE_NOTICIA,
    payload:noticia
})
export const deleteNoticia = (id:string):NoticiasAction=>({
    type:NoticiasActionTypes.DELETE_NOTICIA,
    payload:{id}
})

export const listNoticias = (params:any): NoticiasAction => ({
    type: NoticiasActionTypes.LIST_NOTICIAS,
    payload: params,
});

export const setFiltersNoticias = (params:any): NoticiasAction => ({
    type: NoticiasActionTypes.SET_FILTER,
    payload: params,
})

export const resetNoticias = (): NoticiasAction => ({
    type: NoticiasActionTypes.RESET,
    payload: {},
});

